export class WidgetButton {
  /**
   * The icon displayed on the button
   */
  icon!: string;
  /**
   * The label to display as tooltip
   */
  label!: string;
  /**
   * A function that returns the label dynamically
   * WARNING: it's a good practice to assign an arrow function
   * in order not to lose any reference to objects owned by the class of the widget
   */
  labelFn!: () => string;
  /**
   * Specifies if the button must be clickable
   */
  clickable: boolean = false;
  /**
   * Specifies if the button is pressed (toggle button)
   */
  pressed: boolean = false;
  /**
   * Specifies whether the button must be visible or not
   */
  visible = true;
  /**
   * Specifies whether the button must show notification counter
   */
  notificationCounter: number = 0;
  /**
   * Specifies if the button will be shown only in edit mode
   */
  editOnly: boolean = false;
  /**
   * The function to call when the button is clicked
   * WARNING: it's a good practice to assign an arrow function
   * in order not to lose any reference to objects owned by the class of the widget
   */
  callbackFn!: () => any;


}
